import { useEffect } from "react";
import { useAppSelector } from "../libs/hook";
import { userInfoSelector } from "../libs/selectors/userSelector";
import { useNavigate } from "react-router-dom";
import { RoleConstant } from "../core/constants/role.constant";

export default function RootPage() {

    const currentUser = useAppSelector(userInfoSelector);
    const navigate = useNavigate();

    useEffect(() => {
        if (currentUser.userUid) {
            if (currentUser.roleIds?.includes(RoleConstant.ROLE_ADMIN) || currentUser.roleIds?.includes(RoleConstant.ROLE_WHTQ) || currentUser.roleIds?.includes(RoleConstant.ROLE_WHVN)) {
                navigate('/dashboard');
              } else {
                navigate('/order-mgt');
            }
        }
    }, [currentUser.userUid]);

    return <></>;
}